import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { LocationIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { Statistics } from 'modules/course-detail';

interface IProps {
  name?: string;
  image?: string;
  rating?: number;
  birthday?: string;
  studentCount?: number;
  solvedTestsCount?: number;
  courseStudentsCount?: number;
  addressName?: string;
}

const FirstSection: React.FC<IProps> = ({
  name,
  birthday,
  addressName,
  studentCount,
  solvedTestsCount,
  courseStudentsCount
}) => {
  const t = useTranslations();

  return (
    <>
      <div className="flex items-start gap-3 rounded-lg bg-white px-3 py-2">
        {/* 
        KERAK BO"LADI USTOZNING RASMI BU
        <div className="min-h-27 max-h-27 w-29 min-w-29 relative flex items-center justify-center overflow-hidden rounded-xl bg-gray-100">
          {rating ? (
            <div className="absolute -left-2 top-0 z-10 flex h-5 items-center gap-1 rounded-br-xl bg-white px-1 pl-3 text-sm text-xs">
              <span>
                <StarIcon color="text-yellow-300" size="14" />
              </span>
              {rating}
            </div>
          ) : null}
          <Image
            src={image || '/images/default-no-logo.webp'}
            alt={name?.slice(0, 1) || 'user profile avatar'}
            width={image ? 115 : 30}
            height={image ? 105 : 30}
            className="object-contain"
            title="Kurs ishlab chiquvchining rasmi"
          />
        </div> */}
        <div className="flex-1">
          <p className="mt-1 font-semibold">{name}</p>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
            <div className="flex items-center gap-1 text-xs">
              <UserOutlined className="!text-gray-700" />
              <span className="text-gray-500 ">
                {dayjs().diff(birthday, 'year')} {t('yosh')}
              </span>
            </div>
            <div className="flex items-center gap-1 text-xs">
              <LocationIcon className="size-3.5 !text-gray-700" />
              <span className="text-gray-500 ">{addressName || t('mavjud_emas')}</span>
            </div>
          </div>

          <div className="mt-4 hidden grid-cols-3 gap-3 sm:grid">
            <Statistics className="bg-gray-50" count={studentCount} label={t('oquvchilar_soni')} />
            <Statistics className="bg-gray-50" count={courseStudentsCount} label={t('sotib_olganlar')} />
            <Statistics className="bg-gray-50" count={solvedTestsCount} label={t('yechilgan_testlar_soni')} />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3 sm:hidden">
        <Statistics className="bg-white" count={studentCount} label={t('oquvchilar_soni')} />
        <Statistics className="bg-white" count={courseStudentsCount} label={t('sotib_olganlar')} />
        <Statistics className="bg-white" count={solvedTestsCount} label={t('yechilgan_testlar_soni')} />
      </div>
    </>
  );
};

export default FirstSection;
